<template>
    <b-container>
        <b-row>
            <b-col xs="12" class="border px-4 py-3 bg-light">
                <div><b>Nombre y Apellidos:</b> {{ client.name }} {{ client.surname }}</div>
                <div v-if="!!client.phones"><b>Teléfonos:</b>
                  <span
                    v-for="phone in client.phones"
                    :key="phone.uuid"
                    class="pl-1">
                    {{ phone.phone }}
                  </span>
                </div>
                <div v-else><b>Teléfono:</b> {{ client.phone }}</div>
                <div v-if="!!client.emails"><b>Emails:</b>
                  <span
                    v-for="email in client.emails"
                    :key="email.uuid"
                    class="pl-1">
                    {{ email.email }}
                  </span>
                </div>
                <div v-else><b>Email:</b>{{ client.email }}</div>
            </b-col>
        </b-row>
        <b-row class="mt-2">
            <b-col xs="6" class="mr-1 border p-4 bg-light">
                consultas
            </b-col>
            <b-col xs="6" class="ml-1 border p-4 bg-light">
                respuestas
            </b-col>
        </b-row>
        <b-row class="mt-2">
            <b-col xs="12" class="border p-2 bg-light">
                <div class="py-2 text-center">
                    <b>Notas</b></div>
                <hr class="mt-1 mb-2"/>
                <client-note-list
                    :notes="notes"
                    :class="[!!notes && notes.length ? 'notes-container' : '', 'm-0', 'p-0']"
                    class="m-0 p-0"></client-note-list>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import ClientNoteList from '@/components/clients/notes/ClientNoteList';
    import {getClientNotes} from '@/api/client-note-api';

    export default {
        name: "client-summary",
        components: {
            ClientNoteList
        },
        props: {
            client: {
                type: Object,
                required: true,
                default: function () {
                    return {
                        uuid: null
                    }
                }
            }
        },
        data: function () {
            return {
                notes: []
            }
        },
        mounted() {
            this.getNotes();
        },
        methods: {
            async getNotes() {
                this.$_loadingMixin_showLoading();
                await getClientNotes(this.client.uuid)
                    .then((notes) => {
                        this.notes = notes;
                    })
                    .catch(() => {
                        this.notes = [];
                    });
                this.$_loadingMixin_hideLoading();
            },
            getBadgeVariant(boolean) {
                return (!!boolean ? 'primary' : 'danger')
            }
        },
        watch: {
            client: function (val) {
                this.notes = [];
                this.getNotes();
            }
        }
    }
</script>

<style scoped>
    .notes-container {
        height: 250px;
        overflow-y: scroll;
    }
</style>
